module.exports = vendorLibrary;


//////////////////
// WEBPACK FOOTER
// external "vendorLibrary"
// module id = 48
// module chunks = 0